import { ShoppingBag, UtensilsCrossed, Ticket, PartyPopper, Mountain, Bus, HeartHandshake, Luggage, Tag } from "lucide-react";

// Ordine di visualizzazione delle categorie Hostland Pro (coerente col backend routes/pro.py CATEGORIES).
export const PRO_CATEGORY_ORDER = [
  "Commercio",
  "Cibo e bere",
  "Evento",
  "Divertimento",
  "Avventura",
  "Trasporti",
  "Servizi alla persona",
  "Deposito bagagli",
  "Altro",
];

// Icona + colore + etichette multilingua per ogni categoria (chiave = valore italiano salvato nel DB).
export const PRO_CATEGORY_META = {
  "Commercio":            { icon: ShoppingBag,     color: "#0ea5e9", labels: { it: "Commercio", en: "Shops", fr: "Commerces", es: "Comercios", de: "Geschäfte" } },
  "Cibo e bere":          { icon: UtensilsCrossed, color: "#f97316", labels: { it: "Cibo e bere", en: "Food & Drink", fr: "Manger & Boire", es: "Comer y beber", de: "Essen & Trinken" } },
  "Evento":               { icon: Ticket,          color: "#e11d48", labels: { it: "Eventi", en: "Events", fr: "Événements", es: "Eventos", de: "Events" } },
  "Divertimento":         { icon: PartyPopper,     color: "#a855f7", labels: { it: "Divertimento", en: "Fun", fr: "Loisirs", es: "Diversión", de: "Freizeit" } },
  "Avventura":            { icon: Mountain,        color: "#16a34a", labels: { it: "Avventura", en: "Adventure", fr: "Aventure", es: "Aventura", de: "Abenteuer" } },
  "Trasporti":            { icon: Bus,             color: "#0284c7", labels: { it: "Trasporti", en: "Transport", fr: "Transports", es: "Transporte", de: "Transport" } },
  "Servizi alla persona": { icon: HeartHandshake,  color: "#db2777", labels: { it: "Servizi alla persona", en: "Personal Services", fr: "Services à la personne", es: "Servicios personales", de: "Dienstleistungen" } },
  "Deposito bagagli":     { icon: Luggage,         color: "#7c3aed", labels: { it: "Deposito bagagli", en: "Luggage Storage", fr: "Consigne à bagages", es: "Consigna de equipaje", de: "Gepäckaufbewahrung" } },
  "Altro":                { icon: Tag,             color: "#64748b", labels: { it: "Altro", en: "Other", fr: "Autre", es: "Otros", de: "Sonstiges" } },
};

export const catMeta = (category) => PRO_CATEGORY_META[category] || PRO_CATEGORY_META["Altro"];
export const catLabel = (category, lang = "it") => {
  const m = catMeta(category);
  return m.labels[lang] || m.labels.it;
};
